import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  LayoutDashboard,
  Database,
  BookOpen,
  CreditCard,
  Users,
  CalendarDays,
  Upload,
  BarChart2,
  Settings,
  LogOut,
  X,
  GraduationCap,
} from "lucide-react";
import { logoutUserThunk } from "../../../auth/authThunk";
import "../lms.css";

const BASE_NAV = [
  {
    section: "MAIN MENU",
    items: [
      { label: "Dashboard", icon: LayoutDashboard, to: "/teacher-lms", countKey: null, badge: null },
    ],
  },
];

function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export default function TeacherLmsSidebar({ isOpen, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courses } = useSelector((s) => s.lms || { courses: [] });
  const counts = { courses: (courses && courses.length) || null };

  const handleLogout = async () => {
    await dispatch(logoutUserThunk());
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    navigate("/login");
  };

  const userData = (() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      return {};
    }
  })();

  const userName  = userData?.admin_name || userData?.name || "Teacher User";
  const schoolName = userData?.school_name || "";
  const userRole  = userData?.roles || userData?.role || "Teacher";

  const handleNavClick = () => {
    if (onClose) onClose();
  };

  return (
    <aside className={`lms-sidebar ${isOpen ? "lms-sidebar--open" : ""}`}>
      <div className="lms-sidebar-logo">
        <div className="lms-logo-icon">D</div>
        <div className="lms-logo-text">
          <span className="lms-logo-title">DocMaster LMS</span>
          <span className="lms-logo-sub">TEACHER</span>
        </div>
        <button className="lms-sidebar-close" onClick={onClose} title="Close menu">
          <X size={16} strokeWidth={2} />
        </button>
      </div>

      <nav className="lms-sidebar-nav">
        {BASE_NAV.map((sec) => (
          <div key={sec.section} className="lms-nav-section">
            <span className="lms-nav-section-title">{sec.section}</span>
            {sec.items.map((item) => {
              const Icon = item.icon;
              const countVal = item.countKey ? counts[item.countKey] : null;
              const isIndexActive = item.to === "/teacher-lms" && location.pathname === "/teacher-lms";

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/teacher-lms"}
                  onClick={handleNavClick}
                  className={({ isActive }) =>
                    `lms-nav-item ${isActive || isIndexActive ? "lms-nav-item--active" : ""}`
                  }
                >
                  <Icon className="lms-nav-icon" size={17} strokeWidth={2} />
                  <span className="lms-nav-label">{item.label}</span>
                  {item.badge && <span className="lms-badge lms-badge--new">{item.badge}</span>}
                  {countVal !== null && countVal !== undefined && (
                    <span className="lms-count">{countVal}</span>
                  )}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="lms-sidebar-footer">
        <div className="lms-user-profile">
          <div className="lms-avatar">{getInitials(userName)}</div>
          <div className="lms-user-info">
            <span className="lms-user-name">{userName}</span>
            <span className="lms-user-role">
              {schoolName ? `${userRole} • ${schoolName}` : userRole}
            </span>
          </div>
          <button className="lms-logout-btn" onClick={handleLogout} title="Log Out">
            <LogOut size={16} strokeWidth={2} />
          </button>
        </div>
      </div>
    </aside>
  );
}
